import type { ComponentType } from 'react';
import { Monitor03, Moon01, Sun } from '@kula-ai/icons-core';
import type { ThemePreference } from './colorMode.constants';

export interface ThemeOption {
  value: ThemePreference;
  label: string;
  icon: ComponentType<{ size?: number; color?: string }>;
}

const LIGHT: ThemeOption = { value: 'light', label: 'Light', icon: Sun };
const DARK: ThemeOption = { value: 'dark', label: 'Dark', icon: Moon01 };
const SYSTEM: ThemeOption = {
  value: 'system',
  label: 'System',
  icon: Monitor03,
};

/** Settings > Profile settings > Theme tabs (Figma Settings 13039:44113). */
// System, Light, Dark — the same order as the avatar menu (CORE-5805).
export const THEME_SETTING_OPTIONS: ThemeOption[] = [
  SYSTEM,
  LIGHT,
  { ...DARK, label: 'Dark mode' },
];

/** Avatar menu icon tabs, System first (Figma Settings 13039:44281). */
export const THEME_TOGGLE_OPTIONS: ThemeOption[] = [SYSTEM, LIGHT, DARK];
